import { useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";
import allImgPaths from "../../assets";
import { useAppState } from "../../context";
import Login from "./Login";

const Auth = () => {
  const navigate = useNavigate();
  const {
    isLoggedIn,
    getLatestToken,
    loginKey,
    croleId,
    cotp,
    cphone,
    forceLoginMsg,
    otpVerifyWithMobile,
    updateState,
  } = useAppState("auth");
  const { accessToken } = getLatestToken();

  useEffect(() => {
    if (isLoggedIn && accessToken) {
      navigate("/dashboard");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (loginKey) {
      confirmAlert({
        title: "Login",
        message: forceLoginMsg,
        buttons: [
          {
            className: "cancel-btn",
            label: "No",
            onClick: () => updateState({ loginKey: false }),
          },
          {
            className: "delete-btn",
            label: "Yes",
            onClick: async () => {
              await otpVerifyWithMobile(cphone, cotp, croleId, true);
            },
          },
        ],
        overlayClassName: "overlay-custom-class-name",
        closeOnClickOutside: false,
        closeOnEscape: false,
      });
    }
  }, [loginKey]);

  return (
    <div className="flex justify-center flex-col items-center h-screen">
      <h1 className="text-5xl mb-5 text-red-800">GANICUS PREMIER LEAGUE</h1>
      <div className="border border-gray-300 shadow-md rounded-md p-[40px] flex flex-col md:flex-row items-center md:items-start space-y-6 md:space-y-0 md:space-x-6">
        {/* Logo Section */}
        <div className="w-[330px] mb-2">
          <img src={allImgPaths.gvsLogoImg} alt="Logo" className="" />
        </div>
        {/* Login Section */}
        <div className="w-[350px] md:ml-[40px] ml-0">
          <div className="w-full max-w-sm">
            <Login />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
